module.exports = __webpack_public_path__ + "static/media/raise_shortfall.a8073c17.svg";